import { render, staticRenderFns } from "./sales-vs-labour-cost.vue?vue&type=template&id=65c6a776&"
import script from "./sales-vs-labour-cost.vue?vue&type=script&lang=js&"
export * from "./sales-vs-labour-cost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65c6a776')) {
      api.createRecord('65c6a776', component.options)
    } else {
      api.reload('65c6a776', component.options)
    }
    module.hot.accept("./sales-vs-labour-cost.vue?vue&type=template&id=65c6a776&", function () {
      api.rerender('65c6a776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/sales-vs-labour-cost.vue"
export default component.exports